import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/external-link-line.svg'


const _hoisted_1 = { class: "annotation-target-card" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "annotation-target-text-wrapper" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: _imports_0,
  alt: "External link"
}, null, -1)
const _hoisted_6 = { class: "annotation-target-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "img-fluid annotation-target-icon",
          src: _ctx.image,
          alt: "Target Favicon"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "wrap-text annotation-target-link",
        href: _ctx.target,
        target: "_blank"
      }, [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        _hoisted_5
      ], 8, _hoisted_4),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.target), 1)
    ])
  ]))
}